import { api } from "../helpers";

export const useApi = () => {
  return {
    login: async (user: User): Promise<WebtuorData> => {
      const urlClient =
        window.location.origin === "http://localhost:3000"
          ? "http://bioturingressosc1.hospedagemdesites.ws"
          : window.location.origin;
      const { data } = await api.post(`/login?urlClient=${urlClient}`, {
        ...user,
      });

      return data;
    },
    barcos: async (token: string) => {
      const { data } = await api.get("/api/barcos", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    bancos: async (token: string) => {
      const { data } = await api.get("/api/bancos", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    cidades: async (token: string) => {
      const { data } = await api.get("/api/cidades", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    clientes: async (token: string) => {
      const { data } = await api.get("/api/clientes/0", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    destinos: async (token: string) => {
      const { data } = await api.get("/api/destinos", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    filiais: async (token: string) => {
      const { data } = await api.get("/api/filiais/1", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    gparceiros: async (token: string) => {
      const { data } = await api.get("/api/gparceiros", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    operacoes: async (token: string) => {
      const { data } = await api.get("/api/operacoes/1", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    passeios: async (
      token: string,
      {
        origin,
        destiny,
        date,
      }: {
        origin: string;
        destiny: string;
        date: string;
      }
    ): Promise<Passeios> => {
      const { data } = await api.get(
        `/api/passeios/disponiveisconexao/${date}/${origin}/${destiny}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return data;
    },
    reserva: async (reservas: Reservation) => {
      //      const clientea = Number(reservas.cliente) !== 231;
      //      const clienteb = Number(reservas.cliente) !== 1269;
      //     debugger;
      if (
        Number(reservas.cliente) !== 231 &&
        Number(reservas.cliente) !== 1269
      ) {
        const { data: pdf } = await api.post("/api/reserva", reservas, {
          //          responseType: "blob",
          responseType: "json",
        });
        console.log("pdf: " + pdf);

        return pdf;
      } else {
        const { data: urlRedirect } = await api.post("/api/reserva", reservas);
        console.log("url: " + urlRedirect);

        window.location.href = urlRedirect;
      }
    },
    minhasReservas: async (
      token: string,
      {
        username = "manuelamador@hotmail.com",
        acesso = "venda direta",
        limit,
        offset,
      }: any
    ) => {
      const { data } = await api.post(
        "/api/reserva/minhasreservas",
        { username, acesso, limit, offset },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return data;
    },
    detalheReserva: async (username: string, id: string) => {
      const {
        data: [detail],
      } = await api.get(`/api/reserva/${username}/${id}`);
      return detail;
    },
    getFuncionario: async (id: string) => {
      const {
        data: [funcionario],
      } = await api.get(`/api/funcionario/7/${id}`);
      return funcionario;
    },
    getPasseio: async (id: string) => {
      const {
        data: [passeio],
      } = await api.get(`/api/passeio/${id}`);
      return passeio;
    },
    getParceiro: async (id: string) => {
      const {
        data: [parceiro],
      } = await api.get(`/api/cliente/1/${id}`);
      return parceiro;
    },
    getReserva: async (id: string) => {
      const {
        data: [permissao],
      } = await api.get(`/api/reservas/search/codigo/${id}/codigo`);
      return permissao;
    },
    getUsuario: async (id: string) => {
      const {
        data: [permissao],
      } = await api.get(`/api/usuario/7/${id}`);
      return permissao;
    },
    criarConta: async (username: string) => {
      const { data, status } = await api.post(
        `/api/usuario/vendadireta?email=${username}`
      );
      return { data, status };
    },
    esqueceuSenha: async (username: string) => {
      const { data, status } = await api.get(
        `/api/usuario/recuperarsenha/1/${username}`
      );
      return { data, status };
    },
    alterarSenha: async (
      username: string,
      oldPassword: string,
      newPassword: string
    ) => {
      const { data, status } = await api.post(
        `/api/usuario/trocarsenha?usuario=${username}&vsenhaantiga=${oldPassword}&vnovasenha=${newPassword}`
      );

      return { data, status };
    },
  };
};
